module.exports = __webpack_public_path__ + "img/06.af133ab3.png";